/**
 * @generated SignedSource<<b15f2c46b1a801ab72fc075a9f84003e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueLinks_nativeIssueTable_IssueLinksCell$data = {
  readonly issueLinkConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly issue: {
          readonly fieldsById: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly statusCategory?: {
                  readonly statusCategoryId: string;
                };
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly key: string;
          readonly webUrl: AGG$URL | null | undefined;
        } | null | undefined;
        readonly relationName: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
  readonly " $fragmentType": "issueLinks_nativeIssueTable_IssueLinksCell";
};
export type issueLinks_nativeIssueTable_IssueLinksCell$key = {
  readonly " $data"?: issueLinks_nativeIssueTable_IssueLinksCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueLinks_nativeIssueTable_IssueLinksCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueLinks_nativeIssueTable_IssueLinksCell",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "JiraIssueLinkConnection",
      "kind": "LinkedField",
      "name": "issueLinkConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            }
          ]
        },
        {
          "concreteType": "JiraIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "webUrl"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "key"
                    },
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "ids",
                          "value": [
                            "statusCategory"
                          ]
                        }
                      ],
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsById",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "concreteType": "JiraStatusCategory",
                                      "kind": "LinkedField",
                                      "name": "statusCategory",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "ScalarField",
                                          "name": "statusCategoryId"
                                        }
                                      ]
                                    }
                                  ],
                                  "type": "JiraStatusCategoryField"
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "relationName"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "issueLinkConnection(first:1000)"
    }
  ],
  "type": "JiraIssueLinkField"
};

(node as any).hash = "65d10b85a6176f5587524197d270987b";

export default node;
